import React from 'react';
import { useHistory } from '@shared/core';
import { useEventInfo } from '@shared/utils/eventInfo';
import { Flex } from '@withjoy/joykit';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { MainActionBar } from '../MainActionBar/MainActionBar';
import { useVenueInfo } from '../VenueInfo';

interface VenueContainerProps
  extends Readonly<{
    pageSlug: string;
    eventHandle: string;
    isGuestBookingsTrackerPage?: boolean;
  }> {}

export const VenueContainer: React.FC<VenueContainerProps> = ({ pageSlug, eventHandle, isGuestBookingsTrackerPage }) => {
  const history = useHistory();
  const { eventInfo } = useEventInfo();

  const venueInfoProps = useVenueInfo();

  const onBadgeClick = useEventCallback(() => {
    if (isGuestBookingsTrackerPage) {
      history.push({
        pathname: `/${eventHandle}/edit/accommodations`,
        state: { freeze: true },
      });
    } else {
      history.push({
        pathname: `/${eventHandle}/edit/accommodations/guests`,
        state: { freeze: true },
      });
    }
  });

  return (
    <Flex
      flexDirection="column"
      marginBottom={5}
    >
      <MainActionBar
        eventDate={eventInfo?.finalizedDate?.dateString}
        isGuestBookingsTrackerPage={isGuestBookingsTrackerPage}
        onBadgeClick={onBadgeClick}
        pageSlug={pageSlug}
        venueInfoProps={venueInfoProps}
      />
    </Flex>
  );
};
